import { IAction } from "../../utils/plugin";
import { IDropDownModel } from "./";

export type ReducerFunction = (
  action: IAction,
  model: IDropDownModel
) => IDropDownModel;

const TOGGLE = "dropDown/TOGGLE";

const dropDownReducer: ReducerFunction = (action, model) => {
  switch (action.type) {
    case TOGGLE:
      return { ...model, isClosed: !model.isClosed };
    default:
      return model;
  }
};

export const toggleDropDown = () => ({ type: TOGGLE });

export default dropDownReducer;
